export const SET_TOKEN_RELOAD_LOADER = 'SET_TOKEN_RELOAD_LOADER';
export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER';
export const SET_PASSWORD_RESET_MODE = 'SET_PASSWORD_RESET_MODE';
export const CLEAR_USER_CONTEXT = 'CLEAR_USER_CONTEXT';
export const LOAD_EXTERNAL_GPLACES = 'LOAD_EXTERNAL_GPLACES';
export const REQUEST_TOKEN_RENEWAL = 'REQUEST_TOKEN_RENEWAL';
export const LOAD_ORGANIZATION_CONTEXTS = 'LOAD_ORGANIZATION_CONTEXTS';
export const ADD_TAGS_TO_CONTEXT_ORGANIZATION = 'ADD_TAGS_TO_CONTEXT_ORGANIZATION';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_EXPORT_VIEW = 'SET_EXPORT_VIEW';
export const SET_HAS_ACTIVE_APPROVAL_REQUESTS = 'SET_HAS_ACTIVE_APPROVAL_REQUESTS';